/**
 * Replaces all occurrences of a substring in a string with a new substring.
 * This function mimics the behavior of String.prototype.replaceAll().
 *
 * @param str - The original string.
 * @param search - The substring to replace.
 * @param replacement - The new substring to insert.
 * @returns A new string with all occurrences of `search` replaced by `replacement`.
 */
export function replaceAll(str: string, search: string | RegExp, replacement: string): string {
  // Handle null or undefined inputs
  if (!str) {
    return '';
  }

  // If search is a string, escape special regex characters and create a global regex
  if (typeof search === 'string') {
    search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    search = new RegExp(search, 'g');
  }
  // If search is already a RegExp, ensure it's global
  else if (search instanceof RegExp) {
    search = new RegExp(search.source, 'g' + search.flags.replace('g', ''));
  }

  return str.replace(search, replacement);
}
